module.exports = __webpack_public_path__ + "img/plus_btn.028fce2e.png";